import React from "react";
import Footer from "../../shared/Footer";
import Newsletter from "../../shared/Newsletter";
import Banner from "./Banner";
import Dashboard from "./Dashboard";
import Features from "./Features";
import JoinCompany from "./JoinCompany";
import SubBanner from "./SubBanner";
import SubDashboard from "./SubDashboard";

const Home = () => {
  return (
    <div>
      <Banner />
      <SubBanner />
      <Features />
      <Dashboard />
      <SubDashboard />
      <JoinCompany />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Home;
